module.exports = __webpack_public_path__ + "img/logoutIcon.686a2665.svg";